import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Router } from '@angular/router';
import { ApiEndpoint } from '@shared/shared/enums/api-endpoints.enum';
import { Angulartics2Segment } from 'angulartics2';
import { TRAVEL_BOOKING_TRACKING_PARAMS } from 'app.config';
import * as fromTravelBookingActions from '../actions/travel-booking.actions';

@Injectable()
export class TravelBookingEffects {
  constructor(
    private actions$: Actions,
    private http: HttpClient,
    private router: Router,
    private segment: Angulartics2Segment
  ) {}

  public createTravelBooking$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTravelBookingActions.CREATE_TRAVEL_BOOKING),
      switchMap((action: fromTravelBookingActions.CreateTravelBooking) => {
        return this.http.post(ApiEndpoint.TRAVEL_BOOKINGS, action.payload).pipe(
          map((data) => new fromTravelBookingActions.CreateTravelBookingSuccess(data)),
          catchError((err) => {
            const trackingParams = JSON.parse(localStorage.getItem(TRAVEL_BOOKING_TRACKING_PARAMS));
            this.segment.eventTrack('Travel Checkout - Booking failed', trackingParams);
            localStorage.removeItem(TRAVEL_BOOKING_TRACKING_PARAMS);
            this.router.navigate([`./booking/confirmation/unsuccessful`]);
            return of(new fromTravelBookingActions.CreateTravelBookingError(err));
          })
        );
      })
    )
  );
}
